export default __webpack_public_path__ + "sheldon.png";